import { Check } from "lucide-react";

import QuoteForm from "@/components/QuoteForm";
import { Reveal } from "@/components/Reveal";
import { BRAND } from "@/lib/site";

const CONTACT_INFO = [
  ["Email", BRAND.email, `mailto:${BRAND.email}`],
  ["Phone", BRAND.phone, `tel:${BRAND.phone.replace(/\s+/g, "")}`],
  ["Address", BRAND.address, null],
];

const BENEFITS = [
  "Free showroom layout consultation",
  "20+ product variants across 5 series",
  "Custom branding & RAL colour matching",
  "Container-ready knock-down designs",
];

export default function ContactSection() {
        return (
        <section data-testid="contact-section" id="contact" className="relative py-24 md:py-36 bg-[#F6F7F5]">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                <Reveal className="lg:col-span-5">
                  <div className="overline text-stenzia-green"><span className="kbd-line" /> Get in touch</div>
                  <h2 className="mt-6 font-display font-light text-4xl md:text-5xl tracking-tighter text-charcoal leading-[1.02]">Request a Quote.</h2>
                  <p className="mt-6 text-charcoal/65 leading-relaxed">
                    Share your showroom requirements. Our engineering team will respond within 24 hours with concept drawings and indicative pricing.
                  </p>
    
                  <div className="mt-10 space-y-4">
                    {CONTACT_INFO.map(([k, v, href]) => (
                      <div key={k} className="flex items-start gap-4 group">
                        <div className="w-1 h-12 bg-stenzia-green group-hover:h-14 transition-all duration-500" />
                        <div>
                          <div className="overline text-charcoal/40">{k}</div>
                          {href ? (
                            <a href={href} className="block mt-1 font-display text-lg text-charcoal hover:text-stenzia-green transition-colors">{v}</a>
                          ) : (
                            <div className="mt-1 font-display text-lg text-charcoal">{v}</div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
    
                  <div className="mt-10 p-6 rounded-2xl bg-white border border-charcoal/10">
                    <div className="overline text-stenzia-green">What you get</div>
                    <ul className="mt-4 space-y-3">
                        {BENEFITS.map((x) => (
                            <li key={x} className="flex items-center gap-3 text-sm text-charcoal/75">
                            <Check size={16} className="text-stenzia-green" />
                            {x}
                            </li>
                        ))}
                    </ul>
                  </div>
                </Reveal>
    
                <Reveal delay={1} className="lg:col-span-7">
                  <div className="bg-white rounded-3xl p-6 md:p-10 border border-charcoal/10 shadow-xl">
                    <QuoteForm />
                  </div>
                </Reveal>
              </div>
            </div>
          </section>
  );
}